import { AxiosResponse } from "axios";

import { axiosInstance } from "./axiosInstance";

export const fetcher = async <TResponse>(url: string): Promise<TResponse> => {
  const response = await axiosInstance.get<TResponse>(url);
  return response.data;
};

export const fetcherWithData = async <T, TResponse>(
  url: string,
  body: T
): Promise<TResponse> => {
  const request = {
    params: body
  };

  const response = await axiosInstance.get<TResponse>(url, request);
  return response.data;
};

export const fetcherHead = async (url: string): Promise<AxiosResponse> => {
  return await axiosInstance.head(url);
};
